export const Overrides = {
  assetPrefix: 'https://dhqbrvplips7x.cloudfront.net/digital-desktop/387-387/'
};
